export default __webpack_public_path__ + "images/10adcd5454c07f7e9daa1d4a6fd2614d.jpg";